import * as React from 'react'
import { Link } from 'react-router'
import { compose, pure } from 'recompose'

import * as styles from './LinkButton.css'

interface LinkButtonProps {
  children: any
  to: string | null
  isEnabled: boolean
}

const LinkButton: React.FunctionComponent<LinkButtonProps> = ({ children, to, isEnabled = true }) => {
  let dom = (
    <div className={styles.disabledButton}>
      <div className={styles.text}>{children}</div>
    </div>
  )

  if (isEnabled && to) {
    dom = (
      <Link to={to}>
        <div className={styles.enabledButton}>
          <div className={styles.text}>{children}</div>
        </div>
      </Link>
    )
  }
  return dom
}

export default compose<LinkButtonProps, LinkButtonProps>(pure)(LinkButton)
